export default __webpack_public_path__ + "static/media/facebook-v1-rt30.02ed6de3.svg";